export class Parasha {
    constructor(
        public id?: number,
        public englishName?: string,
        public hebrewName?: string, 
        public current?: boolean
    ) { }

}